import { render, staticRenderFns } from "./AnalyticsUsageClinical.vue?vue&type=template&id=4024b250"
import script from "./AnalyticsUsageClinical.vue?vue&type=script&lang=js"
export * from "./AnalyticsUsageClinical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports